import { serviceAgreementApi } from 'api';
import { ServiceAgreementModificationInformationResponse } from 'pco-product-service-internal-consumer';

export const getModificationDataApi = async (
  serviceAgreementId: string,
): Promise<ServiceAgreementModificationInformationResponse> => {
  const response = await serviceAgreementApi.getServiceAgreementModificationInfo({
    serviceAgreementUid: serviceAgreementId,
  });
  return response as unknown as ServiceAgreementModificationInformationResponse;
};
